import { IdentifierDTO } from '@zazume/zzm-base';

export const DocumentUploadLinkKeys = {
  base: 'documentUploadLink',
  allByRelatedModelId: (relatedModelId: IdentifierDTO): string[] =>
    [DocumentUploadLinkKeys.base, relatedModelId]
};
